type SectionHeadProps = {
  index: string;
  title: string;
  en: string;
  desc?: string;
};

export default function SectionHead({ index, title, en, desc }: SectionHeadProps) {
  return (
    <div className="mb-9 flex flex-col gap-5 border-b border-background-300 pb-5 md:mb-14 md:flex-row md:items-end md:justify-between">
      <div>
        <div className="flex items-center gap-3 font-label text-[11px] uppercase tracking-[0.3em] text-primary-600">
          <span>{index}</span>
          <span className="h-px w-6 bg-primary-400" />
          <span>{en}</span>
        </div>
        <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">{title}</h2>
      </div>
      {desc ? (
        <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-right">{desc}</p>
      ) : null}
    </div>
  );
}